export var SUGGESTION_TYPE;
(function (SUGGESTION_TYPE) {
    SUGGESTION_TYPE[SUGGESTION_TYPE["tag"] = 10] = "tag";
    SUGGESTION_TYPE[SUGGESTION_TYPE["location"] = 11] = "location";
    SUGGESTION_TYPE[SUGGESTION_TYPE["person"] = 12] = "person";
    SUGGESTION_TYPE[SUGGESTION_TYPE["photo_mime_type"] = 13] = "photo_mime_type";
    SUGGESTION_TYPE[SUGGESTION_TYPE["photo_file_name"] = 14] = "photo_file_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["photo_playlist_name"] = 20] = "photo_playlist_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["music_playlist_name"] = 21] = "music_playlist_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["collection_other_name"] = 22] = "collection_other_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["collection_photo_album_name"] = 23] = "collection_photo_album_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["collection_music_playlist_name"] = 24] = "collection_music_playlist_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["collection_highlight_name"] = 25] = "collection_highlight_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["collection_flashback_name"] = 26] = "collection_flashback_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["title"] = 30] = "title";
    SUGGESTION_TYPE[SUGGESTION_TYPE["artist"] = 31] = "artist";
    SUGGESTION_TYPE[SUGGESTION_TYPE["album"] = 32] = "album";
    SUGGESTION_TYPE[SUGGESTION_TYPE["music_mime_type"] = 33] = "music_mime_type";
    SUGGESTION_TYPE[SUGGESTION_TYPE["music_file_name"] = 34] = "music_file_name";
    SUGGESTION_TYPE[SUGGESTION_TYPE["document_mime_type"] = 40] = "document_mime_type";
    SUGGESTION_TYPE[SUGGESTION_TYPE["document_file_name"] = 41] = "document_file_name";
})(SUGGESTION_TYPE || (SUGGESTION_TYPE = {}));
